<!-- Conteneur ancré par OL Overlay — toujours dans le DOM,
     OL gère position:absolute et left/top via son propre système -->
<div #cartePopupEl>

  @if (isVisible) {
    <div
      [ngClass]="popupClasses"
      role="dialog"
      aria-modal="true"
      (keydown)="onKeydown($event)"
    >

      <!-- ── Header — contenu projeté via slot="header" ──────────────────── -->
      @if (showHeader) {
      <div [ngClass]="headerClasses">

        <!-- Icône gauche du titre -->
        <span *ngIf="addIconLeft" class="popup-panel__header-icon popup-panel__header-icon--left">
          <ng-content select="[slot='header-icon-left']"></ng-content>
        </span>

        <!-- Titre -->
        <div class="popup-panel__header-content">
          <ng-content select="[slot='header']"></ng-content>
        </div>

        <!-- Icône droite du titre (entre le titre et le ✕) -->
        <span *ngIf="addIconRight" class="popup-panel__header-icon popup-panel__header-icon--right">
          <ng-content select="[slot='header-icon-right']"></ng-content>
        </span>

        <!-- Bouton fermeture — positionné en absolu pour ne pas impacter le centrage -->
        <button
          class="popup-panel__close"
          type="button"
          aria-label="Fermer"
          (click)="close()"
        >
          <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
            <path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>

      </div>
      }

      <!-- ── Body — contenu projeté (défaut) ─────────────────────────────── -->
      <div class="popup-panel__body">
        <ng-content></ng-content>
      </div>

      <!-- ── Footer — contenu projeté via slot="footer" ──────────────────── -->
      <div class="popup-panel__footer">
        <ng-content select="[slot='footer']"></ng-content>
      </div>

    </div>
  }

</div>
